import React from 'react';
import PlannerFrame from './PlannerFrame';

const HdvEmissionDss = () => {
  return (
    <PlannerFrame
      title="HDV Emission Model DSS"
      src="/hdv-emission-dss.html"
    />
  );
};

export default HdvEmissionDss;
